import Vue from 'vue'
import Router from 'vue-router'
import Landing from '@/views/Landing.vue'
import DemoProject from '@/views/DemoProject.vue'
import DemoExplorer from '@/views/DemoExplorer.vue'
import EditUser from '@/views/usersModule/EditUser.vue'
import UsersList from '@/views/usersModule/UsersList.vue'
import UserProfile from '@/views/usersModule/UserProfile.vue'
import ProjectCreation from '@/views/projectsModule/ProjectCreation.vue'
import ProjectView from '@/views/projectsModule/ProjectView.vue'
import AdminProjects from '@/views/projectsModule/AdminProjects.vue'
import SelfView from '@/views/selfModule/SelfView.vue'
import MarketView from '@/views/marketModule/MarketView.vue'
import OidcCallback from '@/views/oidc/OidcCallback.vue'
import OidcSilentRenew from '@/views/oidc/OidcSilentRenew.vue'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Landing',
      meta: {
        isPublic: true
      },
      component: Landing
    },
    {
      path: '/explorar',
      name: 'ProjectsList',
      meta: { isPublic: true },
      component: DemoExplorer
    },
    {
      path: '/demo/:id',
      name: 'DemoProject',
      meta: { isPublic: true },
      component: DemoProject
    },
    {
      path: '/self',
      name: 'SelfView',
      component: SelfView
    },
    {
      path: '/market',
      name: 'MarketView',
      component: MarketView
    },
    {
      path: '/users/new',
      name: 'NewUser',
      meta: {
        isPublic: true
      },
      component: EditUser
    },
    {
      path: '/users/:id/edit',
      name: 'EditUser',
      component: EditUser
    },
    {
      path: '/users/:id',
      name: 'UserProfile',
      component: UserProfile
    },
    {
      path: '/users',
      name: 'UsersList',
      component: UsersList
    },
    {
      path: '/admin/projects',
      name: 'AdminProjects',
      component: AdminProjects
    },
    {
      path: '/projects/new',
      name: 'ProjectCreation',
      component: ProjectCreation
    },
    {
      path: '/projects/:id',
      name: 'ProjectView',
      meta: {
        isPublic: true
      },
      component: ProjectView
    },
    {
      path: '/projects/:id/edit',
      name: 'ProjectEdition',
      component: ProjectCreation
    },
    {
      path: '/oidc-callback',
      name: 'oidcCallback',
      component: OidcCallback
    },
    {
      path: '/silent-renew-oidc',
      name: 'oidcSilentRenew',
      component: OidcSilentRenew
    },
    {path: '*', redirect: '/'}
  ]
})
router.beforeEach(vuexOidcCreateRouterMiddleware(store))

export default router;
